// 生成 uuid
export function uuidv4() {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}

/**
 * 检查是否可以展示console插件
 * @returns visible true|false
 */
export function onCheckHasConsole() {
  let visible = false;
  const locationHost = window.location.hostname;
  const hosts = [
    "localhost",
    "172.16.20.35",
    "minigame-activity-test.hzwxbz999.cn",
    "minigame-activity-pre.hzwxbz999.cn",
    // "minigame-activity.hzyq628.cn",
  ];
  if (hosts.includes(locationHost)) {
    visible = true;
  }
  return visible;
}

// 根据背景颜色获得一个合适的字体颜色
export function contrastTextColor(backgroundHexColor) {
  let hex = backgroundHexColor
  
  // 如果当前传入的参数以 # 开头,去除当前的
  if (hex.startsWith('#')) {
    hex = hex.substring(1);
  }
  // 如果当前传入的是 3 位小数值，直接转换为 6 位进行处理
  if (hex.length === 3) {
    hex = [hex[0], hex[0], hex[1], hex[1], hex[2], hex[2]].join('')
  }

  if (hex.length !== 6) {
    throw new Error('Invalid background color.' + backgroundHexColor);
  }

  const r = parseInt(hex.slice(0, 2), 16)
  const g = parseInt(hex.slice(2, 4), 16)
  const b = parseInt(hex.slice(4, 6), 16)
  
  if ([r,g,b].some(x => Number.isNaN(x))) {
    throw new Error('Invalid background color.' + backgroundHexColor);
  }

  const textColor = (r * 0.299 + g * 0.587 + b * 0.114) > 186 ? '#333333' : '#fff'
  return textColor
}

export const PAGE_SIZE = 10;
export const getListTotalPage = (total, SIZE = PAGE_SIZE) => {
  let totalPage = 1;
  if (total > SIZE) {
    const num = total / SIZE;
    const truncNum = Math.trunc(total / SIZE);
    if (num === truncNum) {
      totalPage = num;
    } else {
      totalPage = truncNum + 1;
    }
  }
  return totalPage;
};
